import React, { Component } from "react"
import {Switch, Route, NavLink} from "react-router-dom"
import {Form} from './Form'


export class DarePage extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        return (
        <div className="card">
            <div className="card-body">
                <ul className="nav nav-tabs nav-tabs-info">
                    <li className="nav-item">
                        <NavLink to={`/mangarmangaagiinadmin/dare/dare1/`} exact className="nav-link"  activeClassName="active">1-р dare</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={`/mangarmangaagiinadmin/dare/dare2/`} exact className="nav-link"  activeClassName="active">2-р dare</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={`/mangarmangaagiinadmin/dare/dare3/`} exact className="nav-link"  activeClassName="active">3-р dare</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={`/mangarmangaagiinadmin/dare/dare4/`} exact className="nav-link"  activeClassName="active">4-р dare</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={`/mangarmangaagiinadmin/dare/dare5/`} exact className="nav-link"  activeClassName="active">5-р dare</NavLink>
                    </li>
                </ul>
                <div className="tab-content">
                    <Switch>
                        <Route exact path="/mangarmangaagiinadmin/dare/:dare/" component={Form}/>
                    </Switch>
                </div>
            </div>
        </div>
        )

    }

}
